import { render, staticRenderFns } from "./WorkClientTable.vue?vue&type=template&id=d0c3546e&scoped=true&"
import script from "./WorkClientTable.vue?vue&type=script&lang=js&"
export * from "./WorkClientTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientTable.vue?vue&type=style&index=0&id=d0c3546e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c3546e",
  null
  
)

export default component.exports